import From from "./components/Form";
import "./App.css";
import Header from "./components/Header";

function App() {
  return (
    <div className="App">
      <Header />
      <From />
    </div>
  );
}

export default App;
